export enum TransactionState {
	DEFAULT = 0,
	IN_PROGRESS = 2,
	APPROVE_OPERATOR_IN_PROGRESS = 3,
	FAILED = -1,
	SUCCESS = 1,
}
